import Tabs, { Tab } from '@components/atoms/ui-kit/tabs.tsx';
import BillablesBo from '@pages/back-office/billables-bo.tsx';
import { Cycles } from '@components/my-account/billing-and-subscription/cycles.tsx';
import OneOffChargesList from '@components/back-office/usage-revenue/one-off-charges-list';
import { Receipt, RefreshCw, PlusCircle } from 'lucide-react';

export enum BillableTabs {
  Billables = 'Billables',
  OneOffCharges = 'One-Off Charges',
  Cycles = 'Cycles'
}

export default function BillableDetailsBo() {
  const tabs: Tab[] = [
    {
      id: 0,
      name: (
        <span className="flex items-center gap-2">
          <Receipt className="h-4 w-4" />
          {BillableTabs.Billables}
        </span>
      ),
      component: <BillablesBo />
    },
    {
      id: 1,
      name: (
        <span className="flex items-center gap-2">
          <PlusCircle className="h-4 w-4" />
          {BillableTabs.OneOffCharges}
        </span>
      ),
      component: <OneOffChargesList />
    },
    {
      id: 2,
      name: (
        <span className="flex items-center gap-2">
          <RefreshCw className="h-4 w-4" />
          {BillableTabs.Cycles}
        </span>
      ),
      component: <Cycles />
    }
  ];

  return (
    <Tabs tabs={tabs} searchParams minHeight={'92vh'} maxHeight={'92vh'} />
  );
}
